import type { columnRenderOptions } from '@/vantage/types/TableConfig.types';
import DOMPurify from 'dompurify';
import _ from 'lodash';

import { MultiTypeIcon } from '@/vantage/components/atoms/MultiTypeIcon.atom';
import { translateLabelIfPossible } from '@/vantage/utilities';

export const BooleanColumnRenderer: React.FunctionComponent<columnRenderOptions> = (selection) => {
  return (
    <div
      data-testid={selection?.testId}
      data-qtip-is-html
      data-qtip-placement="right"
      data-qtip-text={`<div data-testid='tooltip-${selection?.testId}'>${translateLabelIfPossible(selection)}</div>`}
      className="flexColumnContainer flexCenter height-maximum">
      {_.has(selection, 'icon') && (
        <MultiTypeIcon
          icon={selection.icon}
          iconFill={selection.iconFill}
          type={selection.iconFill ? 'color' : 'white'}
        />
      )}
      {!_.has(selection, 'icon') && <span>{translateLabelIfPossible(selection)}</span>}
    </div>
  );
};

export const ArrayColumnRenderer: React.FunctionComponent<string[]> = (selection) => {
  return <div className="text-center">{selection.join(', ')}</div>;
};

export const SanitizedHtmlColumnRenderer: React.FunctionComponent<string> = (selection) => {
  const clean = DOMPurify.sanitize(selection, { ALLOWED_TAGS: [] });
  return <div>{clean}</div>;
};
